import { render, staticRenderFns } from "./PrimaryButton.vue?vue&type=template&id=0e18e6e8"
import script from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports